<template>
    <div class="message-index">
        <el-container class="message-container">
            <el-aside width="200px">
                <div class="navigation is-active" name="notice" @click="handleNavClick(1, 'notice')">
                    <div class="red-dot iconfont icon-yuandian"></div>
                    消息通知
                </div>
                <div class="navigation marginLeft15" name="warn" @click="handleNavClick(2, 'warn')">消息提醒设置</div>
            </el-aside>
            <el-main>
                <notice v-if="activeName === 'notice'"></notice>
                <warn v-if="activeName === 'warn'"></warn>
            </el-main>
        </el-container>
    </div>
</template>
<script>
import notice from "./components/notice";
import warn from "./components/warn";
export default {
    name: "MessageIndex",
    components: {
        notice,
        warn,
    },
    data() {
        return {
            activeName: "notice",
        };
    },
    computed: {
        // unreadTotal: function() {
        //     return this.$store.getters.getUnreadTotal;
        // },
    },

    methods: {
        handleNavClick(type, eleName) {
            this.activeName = eleName;
            this.cutoverTab(eleName);
        },
        cutoverTab(eleName) {
            let tabs = document.getElementsByClassName("navigation");
            for (let i = 0, len = tabs.length; i < len; i++) {
                let name = tabs[i].getAttribute("name");
                if (tabs[i].className.indexOf("is-active") !== -1) {
                    if (name !== eleName) {
                        tabs[i].classList.remove("is-active");
                    } //删除class
                } else {
                    if (name === eleName) {
                        tabs[i].classList.add("is-active");
                    } //删除class
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.message-index {
    height: 100%;
    .message-container {
        height: 100%;
        .el-main {
            padding: 20px 20px 0 20px;
        }
        .el-aside {
            border-right: 1px solid #cdcfd4;
            padding-top: 20px;
            .navigation {
                padding: 9px 0 9px 20px;
            }
            .red-dot {
                margin-right: -5px;
                color: #fc615d;
                display: inline-block;
            }
            .marginLeft15 {
                margin-left: 15px;
            }
            .is-active {
                background-color: #f4f7fa;
                color: #3aa17f;
                border-right: 4px solid #3aa17f;
            }
        }
    }
}
</style>
